"use client";

import Video from "@/components/UIkit/Video";
import BlockHeader from "@/components/UIkit/BlockHeader";
import React, { ReactNode } from "react";
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";

export interface TeamBlockCustomProps {
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  id?: string;
  videoUrl?: string | { url: string };
  youtubeLink?: string;
}

export default function TeamBlockCustom({
  title,
  subtitle,
  id,
  videoUrl = "https://ap.education/static/video/trailers/new-home/home-who-we-are.webm",
  youtubeLink,
}: TeamBlockCustomProps) {
  return (
    <div id={id} data-meta="TeamBlockCustom" className="my-14">
      <BlockHeader
        title={title}
        subtitle={subtitle}
      />
      <div className="flex justify-center mx-auto px-6 py-6 sm:py-4 lg:px-8 max-w-7xl">
        <Video videoUrl={videoUrl} youtubeLink={youtubeLink} />
      </div>
    </div>
  );
}